import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 16h.01","key":"svg-0"}],["path",{"d":"M12 7v1","key":"svg-1"}],["path",{"d":"M3 3l18 18","key":"svg-2"}]]

const IconAlertSmallOff = createReactComponent('outline', 'alert-small-off', 'AlertSmallOff', __iconNode);

export default IconAlertSmallOff;